// Supported UI languages for the WithMe platform.
// Keep this list in sync with backend validation sets.
export const SUPPORTED_LANGUAGES = [
   { code: 'en',    label: 'English (UK)', nativeLabel: 'English (UK)', short: 'EN' },
   { code: 'en-US', label: 'English (US)', nativeLabel: 'English (US)', short: 'EN-US' },
   { code: 'fr', label: 'French',     nativeLabel: 'Français',   short: 'FR' },
   { code: 'es', label: 'Spanish',    nativeLabel: 'Español',    short: 'ES' },
   { code: 'de', label: 'German',     nativeLabel: 'Deutsch',    short: 'DE' },
   { code: 'pt', label: 'Portuguese', nativeLabel: 'Português',  short: 'PT' },
   { code: 'it', label: 'Italian',    nativeLabel: 'Italiano',   short: 'IT' },
   { code: 'no', label: 'Norwegian',  nativeLabel: 'Norsk',      short: 'NO' },
   { code: 'pl', label: 'Polish',     nativeLabel: 'Polski',     short: 'PL' },
   { code: 'nl', label: 'Dutch',      nativeLabel: 'Nederlands', short: 'NL' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const DEFAULT_LANGUAGE = 'en';

export const getLanguageByCode = (code) =>
   SUPPORTED_LANGUAGES.find((l) => l.code === code) || null;
